module.exports = __webpack_public_path__ + "divulgacao.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images2/icons/divulgacao.png
 ** module id = 751
 ** module chunks = 0
 **/